











































































import { Component, Prop } from "vue-property-decorator";
import {
  ADMIN_SIDEBAR_OPTIONS,
  MANAGE_SPACE_IN_SUPER_SPACE_SIDEBAR,
  MANAGE_SPACE_OPTIONS,
} from "@/resources/constants/sidebarMenu";
import ManageUsersComponent from "@/app/components/manageSpace/components/users/manageUsers.component.vue";
import CustomizeSpaceComponent from "@/app/components/manageSpace/components/space/customizeSpace/customizeSpace.component.vue";
import UpdateRoomsComponent from "@/app/components/manageSpace/components/space/updateRooms/updateRooms.component.vue";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import InviteUsersComponent from "@/app/components/manageSpace/components/users/inviteUsers/inviteUsers.component.vue";
import SpaceSettingsComponent from "@/app/components/manageSpace/components/space/spaceSettings/spaceSettings.component.vue";
import DashboardComponent from "@/app/admin/components/dashboard/dashboard.component.vue";
import ManageLogsComponent from "../users/manageLogs.component.vue";
import AnnouncementsComponent from "../../announcements/announcements.component.vue";
import UpdatePosterComponent from "../space/updatePoster/updatePoster.component.vue";

@Component({
  name: "manage-space-in-super-space-component",
  components: {
    SpaceSettingsComponent,
    InviteUsersComponent,
    UpdateRoomsComponent,
    CustomizeSpaceComponent,
    ManageUsersComponent,
    DashboardComponent,
    ManageLogsComponent,
    AnnouncementsComponent,
    UpdatePosterComponent,
  },
})
export default class ManageSpaceInSuperSpaceComponent extends mixins(
  UserValidator
) {
  @Prop() active;
  sidebarMenu = MANAGE_SPACE_IN_SUPER_SPACE_SIDEBAR;
  MANAGE_SPACE_OPTIONS = MANAGE_SPACE_OPTIONS;
  ADMIN_SIDEBAR_OPTIONS = ADMIN_SIDEBAR_OPTIONS;
  menuActive = ADMIN_SIDEBAR_OPTIONS.DASHBOARD.toString();
  owner = null;
  mounted(): void {
    this.owner = this.isSuperSpaceOwner();
  }
  get activeModal(): boolean {
    return this.active;
  }
  set activeModal(e) {
    this.$emit("close-modal");
  }
  closeModal() {
    this.$emit("close-modal");
  }
}
